import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, SmartphoneIcon, HeadsetIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-14 px-6 bg-white relative border-y border-gold/20" data-id="element-136">
      <div className="max-w-5xl mx-auto text-center" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-6" data-id="element-138">
          <div className="w-20 h-20 bg-blush rounded-full flex items-center justify-center border-2 border-gold/30 shadow-inner" data-id="element-139">
            <ShieldCheckIcon className="w-10 h-10 text-burgundy" data-id="element-140" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-141">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-burgundy font-serif" data-id="element-142">
            Tu compra está protegida
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-143">
          {[{
          icon: <LockIcon className="w-6 h-6" data-id="element-144" />,
          title: 'Pago 100% Seguro',
          desc: 'Procesado con encriptación SSL'
        }, {
          icon: <SmartphoneIcon className="w-6 h-6" data-id="element-145" />,
          title: 'Acceso Inmediato',
          desc: 'Recibe tu eBook al instante'
        }, {
          icon: <HeadsetIcon className="w-6 h-6" data-id="element-146" />,
          title: 'Soporte Personalizado',
          desc: 'Atención por email'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.3 + index * 0.1
        }} className="flex flex-col items-center p-4 md:p-6 bg-cream rounded-xl border border-gold/20 shadow-sm" data-id="element-147">
              <div className="text-gold mb-3" data-id="element-148">{item.icon}</div>
              <h3 className="font-bold text-burgundy mb-1 text-base font-serif" data-id="element-149">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-150">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}